/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: the_goobadooba (https://sketchfab.com/the_goobadooba)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/chrome-dino-3d-animated-d1e8d87cae4e4e5da7880b695a54d678
Title: Chrome dino- 3d animated!
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import * as THREE from "three";

export function DinoModel({ isJumping, isDucking, isDead, landed, isRunning }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/dino/chrome_dino-_3d_animated.glb')
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    if (!group.current) return;
    const bodyMat = new THREE.MeshStandardMaterial({ color: '#8A2D3B', roughness: 0.8 });
    group.current.traverse((o) => {
      if (!o.isMesh) return;
      o.castShadow = true;
      o.receiveShadow = true;
      if (o.name === 'Object_38' || o.name === 'Object_40') { o.visible = false; return; }
      o.material = bodyMat;
    });
  }, []);
  // console.log(actions)

  useEffect(() => {
    let name, loopOnce = false, clamp = false;

    if (isDead) {
      name = 'chrome dino death'; loopOnce = true; clamp = true;
    } else if (isJumping) {
      name = 'chrome dino jump';
    } else if (landed) {
      name = 'chrome dino land'; loopOnce = true;
    } else if (isDucking) {
      name = 'chrome dino duck run';
    } else {
      // Always run — the dino world scrolls constantly
      name = 'chrome dino run';
    }

    function playAction(actionName, once = false, clamped = false) {
      Object.values(actions).forEach((a) => a.fadeOut(0.08));
      const action = actions[actionName];
      if (!action) return;
      action.reset();
      action.setLoop(once ? THREE.LoopOnce : THREE.LoopRepeat, once ? 1 : Infinity);
      action.clampWhenFinished = clamped;
      action.fadeIn(0.08).play();
    }

    playAction(name, loopOnce, clamp);
  }, [isJumping, isDucking, isDead, landed, isRunning])
  return (
    <group ref={group} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]} scale={1.295}>
          <group name="root">
            <group name="GLTF_SceneRootNode" rotation={[Math.PI / 2, 0, 0]}>
              <group name="_31">
                <group name="body_30" position={[0, 0.625, 0]}>
                  <group name="cube_0" position={[0, -0.625, 0]}>
                    <mesh
                      name="Object_6"
                      castShadow
                      receiveShadow
                      geometry={nodes.Object_6.geometry}
                      material={materials.material_0}
                    />
                  </group>
                  <group name="arm2_3" position={[0.313, 0.125, -0.313]}>
                    <group name="cube_1" position={[0, -0.297, 0.274]}>
                      <mesh
                        name="Object_9"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_9.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_2" position={[0, -0.297, 0.274]}>
                      <mesh
                        name="Object_11"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_11.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="leg_7" position={[0.188, -0.188, 0]}>
                    <group name="cube_4" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_14"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_14.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_5" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_16"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_16.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_6" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_18"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_18.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="leg2_12" position={[-0.313, -0.188, 0]}>
                    <group name="cube_9" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_21"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_21.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_10" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_23"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_23.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_11" position={[0.313, -0.438, 0]}>
                      <mesh
                        name="Object_25"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_25.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="arm_15" position={[-0.188, 0.188, -0.313]}>
                    <group name="cube_13" position={[-0.125, -0.313, 0.313]}>
                      <mesh
                        name="Object_28"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_28.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_14" position={[-0.125, -0.313, 0.313]}>
                      <mesh
                        name="Object_30"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_30.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="tail_18" position={[0, 0.125, 0.313]}>
                    <group name="cube_16" position={[0, -0.75, -0.313]}>
                      <mesh
                        name="Object_33"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_33.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_17" position={[0, -0.75, -0.313]}>
                      <mesh
                        name="Object_35"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_35.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="sweat_21" position={[0, 1.25, -0.125]}>
                    <group name="cube_19" position={[0, -1.313, 0]}>
                      <mesh
                        name="Object_38"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_38.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_20" position={[0, -1.313, 0]}>
                      <mesh
                        name="Object_40"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_40.geometry}
                        material={materials.material_0}
                      />
                    </group>
                  </group>
                  <group name="neck_29" position={[0, 0.125, 0]}>
                    <group name="cube_22" position={[0, -0.75, 0]}>
                      <mesh
                        name="Object_43"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_43.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="cube_23" position={[0, -0.75, 0]}>
                      <mesh
                        name="Object_45"
                        castShadow
                        receiveShadow
                        geometry={nodes.Object_45.geometry}
                        material={materials.material_0}
                      />
                    </group>
                    <group name="head_28" position={[0, 0.563, -0.375]}>
                      <group name="cube_24" position={[0, -1.313, 0.375]}>
                        <mesh
                          name="Object_48"
                          castShadow
                          receiveShadow
                          geometry={nodes.Object_48.geometry}
                          material={materials.material_0}
                        />
                      </group>
                      <group name="cube_25" position={[0, -1.313, 0.375]}>
                        <mesh
                          name="Object_50"
                          castShadow
                          receiveShadow
                          geometry={nodes.Object_50.geometry}
                          material={materials.material_0}
                        />
                      </group>
                      <group name="jaw_27" position={[0, 0.063, -0.063]}>
                        <group name="cube_26" position={[0, -1.375, 0.438]}>
                          <mesh
                            name="Object_53"
                            castShadow
                            receiveShadow
                            geometry={nodes.Object_53.geometry}
                            material={materials.material_0}
                          />
                        </group>
                      </group>
                    </group>
                  </group>
                </group>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/dino/chrome_dino-_3d_animated.glb')